import * as React from 'react';
import { observer } from 'mobx-react';
import { modalWithCustomInput } from 'Views/Components/Modal/CustomModal';
import { action, observable } from 'mobx';
import { SelectInput } from 'Views/Components/New/SelectInput';
import { TextInput } from 'Views/Components/New/TextInput';
import { stringIsEmpty, stringNotEmpty } from 'Util/TypeGuards';
import { cacheType, cacheTypeOptions } from 'Models/Enums';
import { clearCache } from 'Services/Api/_HumanWritten/CacheService';
import If from '../../If/If';

export interface CacheModal {
	cacheModel: {
		selectedCache: string;
		ferryTripId?: string;
	};
}

export const CacheModalContent = observer(({ cacheModel }: CacheModal) => {
	const options = (Object.keys(cacheTypeOptions) as cacheType[]).map(x => ({
		value: x,
		label: cacheTypeOptions[x],
	}));

	return (
		<div className="flex flex-col gap-4">
			<p className="text-sm text-gray-600">Select a cache to clear.</p>
			<SelectInput
				label="Cache to clear"
				placeholder="Select cache to clear"
				required
				options={options}
				value={options.find(o => o.value === cacheModel.selectedCache) ?? null}
				onChange={action((opt: unknown) => {
					cacheModel.selectedCache = (opt as { value: cacheType } | null)?.value ?? '';
				})}
			/>
		</div>
	);
});

export const RenderClearCacheModal = async (toClearCache: boolean = true) => {
	const cacheModel = observable({
		selectedCache: '',
		ferryTripId: '',
	});

	const ObservableModalContent = observer(() => {
		return <CacheModalContent cacheModel={cacheModel} />;
	});

	const confirmed = await modalWithCustomInput('Clear Cache', <ObservableModalContent />, {
		cancelText: 'Cancel',
		confirmText: 'Confirm',
		actionClassName: 'cache-modal',
		resolveOnCancel: false,
		onConfirm: action(() => {
			return true;
		}),
	});

	if (!confirmed || stringIsEmpty(cacheModel.selectedCache)) {
		return;
	}

	if (toClearCache && stringNotEmpty(cacheModel.selectedCache)) {
		await clearCache(cacheModel.selectedCache as cacheType);
	}
};
